/// <amd-module name="typeahead/features/SelectInputElement" />
/// <amd-dependency path="jquery" name="$"/>

import {Experiment} from "typeahead/core/Experiment";
import {IExperimentalFeature} from "typeahead/core/IExperimentalFeature";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IInputElementFocusByHumanOrScriptHandler}
    from "typeahead/core/presentation/IInputElementFocusByHumanOrScriptHandler";
import * as StripingConfiguration from "typeahead/core/StripingConfiguration";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Flights.Search"],
    },
    // An empty striping configuration at the end enables the feature in all contexts that are ignored by all preceding
    // striping configurations.
    {},
];

export class SelectInputElementOnFocus
        implements IExperimentalFeature, IInputElementFocusByHumanOrScriptHandler {
    private static enableAutoSelection($inputElement): void {
        let selectAllText = () => {
            let htmlInputEl: HTMLInputElement = <HTMLInputElement> $($inputElement)[0];
            /* Below condition was updated to fix an issue very similar to -
                    https://jira.sea.corp.expecn.com/jira/servicedesk/customer/portal/262/ECOMSVC-2745
                    (caused when a combination of mouse and tab is used between two typeahead inputs) */
            if (htmlInputEl &&  $($inputElement).val() && document.activeElement === htmlInputEl) {
                htmlInputEl.setSelectionRange(0, 9999);
            }
        };
        setTimeout(() => {
            selectAllText();
        }, 0);
    }

    public getExperiments(): Experiment[] {
        return StripingConfiguration.getExperiments(configuration);
    }

    public handleInputElementFocusByHumanOrScript($inputElement: JQuery, context: IContext): void {
        if (ExecutionHelper.shouldExecute(context, configuration)) {
            SelectInputElementOnFocus.enableAutoSelection($inputElement);
        }
    }
}
